import React, { useState, useRef, useEffect } from "react";
import { Col, OverlayTrigger, Popover, Row } from "react-bootstrap";
import { SiDotnet } from "react-icons/si";
import { DiJavascript1, DiReact, DiMysql, DiDjango, DiHtml5 } from "react-icons/di";
import { SiPostgresql, SiSpringboot, SiTailwindcss, SiFlask } from "react-icons/si";
import { FaJava, FaPython } from "react-icons/fa";

const popover = (name, blogLink, description) => (
  <Popover id="popover-basic">
    <Popover.Header as="h3">{name}</Popover.Header>
    <Popover.Body>
      {description}
      <br />
      <a href={blogLink} target="_blank" rel="noopener noreferrer">Learn more</a>
    </Popover.Body>
  </Popover>
);

function Techstack() {
  const [activePopover, setActivePopover] = useState(null);
  const techStackRef = useRef(null);

  const techStack = [
    { Icon: SiDotnet, name: ".NET", blogLink: "https://kalyanblogs.vercel.app/blog/kalyan/what-is-dotnet", description: ".NET is a free, cross-platform, open-source developer platform for building many different types of applications." },
    { Icon: DiJavascript1, name: "JavaScript", blogLink: "https://developer.mozilla.org/en-US/docs/Web/JavaScript", description: "JavaScript is a lightweight, interpreted programming language with first-class functions." },
    { Icon: DiReact, name: "React", blogLink: "https://reactjs.org/", description: "React is a JavaScript library for building user interfaces." },
    { Icon: FaPython, name: "Python", blogLink: "https://www.python.org/", description: "Python is an interpreted, high-level and general-purpose programming language." },
    { Icon: SiPostgresql, name: "PostgreSQL", blogLink: "https://www.postgresql.org/", description: "PostgreSQL is a powerful, open source object-relational database system." },
    { Icon: DiMysql, name: "MySQL", blogLink: "https://www.mysql.com/", description: "MySQL is an open-source relational database management system." },
    { Icon: FaJava, name: "Java", blogLink: "https://www.java.com/", description: "Java is a class-based, object-oriented programming language designed for portability and cross-platform development." },
    { Icon: SiSpringboot, name: "Spring Boot", blogLink: "https://spring.io/projects/spring-boot", description: "Spring Boot makes it easy to create stand-alone, production-grade Spring based Applications." },
    { Icon: DiDjango, name: "Django", blogLink: "https://www.djangoproject.com/", description: "Django is a high-level Python Web framework that encourages rapid development and clean, pragmatic design." },
    { Icon: DiHtml5, name: "HTML5", blogLink: "https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/HTML5", description: "HTML5 is the latest evolution of the standard that defines HTML." },
    { Icon: SiTailwindcss, name: "Tailwind CSS", blogLink: "https://tailwindcss.com/", description: "Tailwind CSS is a utility-first CSS framework for rapidly building custom designs." },
    { Icon: SiFlask, name: "Flask", blogLink: "https://flask.palletsprojects.com/", description: "Flask is a lightweight WSGI web application framework in Python." },
  ];

  useEffect(() => {
    function handleClickOutside(event) {
      if (techStackRef.current && !techStackRef.current.contains(event.target)) {
        setActivePopover(null);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleIconClick = (index) => {
    setActivePopover(activePopover === index ? null : index);
  };

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }} ref={techStackRef}>
      {techStack.map((tech, index) => (
        <OverlayTrigger
          key={index}
          trigger="click"
          placement="auto"
          show={activePopover === index}
          overlay={popover(tech.name, tech.blogLink, tech.description)}
        >
          <Col xs={4} md={2} className="tech-icons" onClick={() => handleIconClick(index)}>
            <tech.Icon />
          </Col>
        </OverlayTrigger>
      ))}
    </Row>
  );
}

export default Techstack;